import { render, staticRenderFns } from "./bardf.vue?vue&type=template&id=7c455eaf&scoped=true"
import script from "./bardf.vue?vue&type=script&lang=js"
export * from "./bardf.vue?vue&type=script&lang=js"
import style0 from "./bardf.vue?vue&type=style&index=0&id=7c455eaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c455eaf",
  null
  
)

export default component.exports